import React from 'react'

/*
 * Use this component as a wrapper for button text to avoid React rendering error when the user
 * has turned autotranslate on in their browser and is translating the currently Finnish-only
 * account registration forms.
 * See: https://github.com/facebook/react/issues/11538#issuecomment-390386520
 */
export const PageTranslationSafeLabel: React.FC<{
  children: React.ReactNode
  className?: string
}> = ({ children, className }) => {
  return <span className={className}>{children}</span>
}
